import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative pt-32 pb-20 px-4 sm:px-6 bg-[#F5F0EB] overflow-hidden" data-id="element-82">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-83">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-50 text-amber-800 text-sm font-medium mb-8 border border-amber-200" data-id="element-84">
          <span className="relative flex h-2 w-2" data-id="element-85">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" data-id="element-86"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500" data-id="element-87"></span>
          </span>
          For students & young emigrants (20-35)
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-6xl font-bold text-neutral-900 leading-[1.1] mb-6 tracking-tight" data-id="element-88">
          You don't need "settling in." <br className="hidden md:block" data-id="element-89" />
          <span className="text-amber-700 italic" data-id="element-90">You need a system</span> for
          the first 14 days.
        </motion.h1>

        {/* Subhead */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-neutral-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-91">
          Stop paying the "foreigner tax" in silence. Land, stabilize, and stop
          signing things under pressure.
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-92">
          <Button size="lg" className="w-full sm:w-auto text-lg px-8 py-6 shadow-xl shadow-neutral-900/10 hover:shadow-neutral-900/20 transition-all transform hover:-translate-y-0.5" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-93">
            Get the Plan
            <ArrowRight className="ml-2 h-5 w-5" data-id="element-94" />
          </Button>
          <p className="text-sm text-neutral-500 mt-2 sm:mt-0" data-id="element-95">
            Instant digital download
          </p>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 40,
        rotate: 1
      }} animate={{
        opacity: 1,
        y: 0,
        rotate: 1
      }} whileHover={{
        rotate: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative mx-auto max-w-3xl rounded-2xl shadow-2xl shadow-neutral-900/20 border-4 border-[#FAF8F6] overflow-hidden transform transition-transform duration-500" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/5oiZAXocQJNkA3VkCMSXfG/heylloyd-image-1770625518169.png" alt="Person using the 14-Day Settle-In Anywhere Kit on a tablet" className="w-full h-auto object-cover" data-id="element-97" />
        </motion.div>

        {/* Lead Copy */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mt-20 text-left max-w-prose mx-auto space-y-6 text-lg text-neutral-700 leading-relaxed border-l-4 border-neutral-900 pl-6 md:pl-8 py-2" data-id="element-98">
          <p className="font-serif text-2xl text-neutral-900 font-bold mb-4" data-id="element-99">
            You didn't move countries to become a full-time researcher.
          </p>
          <p data-id="element-100">
            But in the first two weeks, that's what life demands: rules you
            don't know, paperwork you've never seen, prices you can't judge, and
            people who can smell that you're new.
          </p>
          <p data-id="element-101">
            And when you're tired, jet-lagged, and under pressure… you don't
            make "bad decisions."
          </p>
          <p className="font-semibold text-neutral-900" data-id="element-102">
            You make fast decisions.
          </p>
          <p data-id="element-103">
            That's how the "foreigner tax" gets paid: in deposits you can't get
            back, contracts you didn't understand, fees you didn't see, and
            awkward situations you don't know how to exit.
          </p>
          <p className="text-amber-700 font-medium italic" data-id="element-104">
            The 14-Day Settle-In Anywhere Kit is the system to stop that.
          </p>
        </motion.div>
      </div>
    </section>;
}